// import { uploadData, remove, s3GetURL, list, get  } from "aws-amplify/storage";

// export async function s3Upload(file, folder) {
//     const filename = `${folder}/${file.name}`;

//   const stored = await uploadData(filename, file, {
//     contentType: file.type
//     });


//   return stored.key;
// }

// export async function s3Delete(key) {


// const stored = await remove(key);


// return stored.key;
// }

// export async function _s3GetURL(file, folder) {
//   let filename = null;  
//   if (folder != null){
//       filename = `${folder}/${file}`;
//     }else{
//       filename = `${file}`;
//     }
//     console.log("File name-"+filename);
//     const url = await get(filename, { expires: 900,level: 'public' });
//     console.log(url);
//     return url;


// }

// export async function s3GetFolderFiles(folder,prefix) {
//     //const currentConfig = configure();
//     //console.log(currentConfig);
//     console.log(`${folder}/${prefix}`);
//     const result  = await list(`${folder}/${prefix}`);
//     console.log(result);
//     return result;



// }


import { uploadData, remove, getUrl, list } from "aws-amplify/storage";
import config from "../config";

/**
 * Uploads a file to a given S3 folder.
 * @param {File} file - The file to upload.
 * @param {string} folder - The S3 folder path.
 * @returns {string} The S3 key of the uploaded file.
 */
export async function s3Upload(file, folder) {
  const filename = `${folder}/${file.name}`;
  
  const uploadOperation = uploadData({ 
    path: filename, 
    data: file,
    options: {
        contentType: file.type
    }
  });
  const result = await uploadOperation.result;
  return result.path;
}

/**
 * Deletes a file from S3.
 * @param {string} key - The S3 key to delete.
 * @returns {string} The deleted S3 key.
 */
export async function s3Delete(key) {
  const normalizedPath = String(key || "").replace(/^\/+/, "");

  try {
    const stored = await remove({ path: normalizedPath });
    return stored?.path || normalizedPath;
  } catch (error) {
    // Backward-compatible fallback for environments still expecting the old signature.
    const stored = await remove(normalizedPath);
    return stored?.key || stored?.path || normalizedPath;
  }
}

/**
 * Gets a temporary public URL for a file in S3.
 * @param {string} file - The file name or key.
 * @param {number} expires - URL expiration in seconds (default 900s).
 * @param {boolean} validateObjectExistence - Validate object exists before returning URL.
 * @returns {string} The temporary URL.
 */
export async function _s3GetURL(file, expires = 900, validateObjectExistence = false) {
  const MAX_EXPIRES_SECONDS = 60 * 60 * 24 * 7;
  const DEFAULT_EXPIRES_SECONDS = 900;

  let filename = String(file || "");
  let expiresIn = expires;

  // Backward compatibility: old callers passed folder as second arg.
  if (typeof expires === "string") {
    const folder = expires;
    filename = `${folder}/${filename}`;
    expiresIn = DEFAULT_EXPIRES_SECONDS;
  }

  const parsedExpires = Number(expiresIn);
  const safeExpires = Number.isFinite(parsedExpires)
    ? Math.min(Math.max(parsedExpires, 1), MAX_EXPIRES_SECONDS)
    : DEFAULT_EXPIRES_SECONDS;

  const url = await getUrl({
    path: filename,
    options: {
      validateObjectExistence,
      expiresIn: safeExpires,
      useAccelerateEndpoint: false,
    }
  });
  // console.log(url.url);
  return url.url.href;
}

/**
 * TODO
 * Lists all files in a given S3 folder/prefix.
 * @param {string} paramPath - The S3 folder path.
 * @returns {Array} Array of file objects { key, eTag, lastModified, size }.
 */
export async function s3GetFolderFiles(paramPath) {
  const trimmedPath = String(paramPath || "")
    .replace(/^\/+/, "")
    .replace(/\/+$/, "");
  const path = `${trimmedPath}/`;
  console.log("Listing S3 folder:", path);

  // Use a direct S3 list request so the URL query contains only the prefix parameter.
  const bucket = config?.s3?.BUCKET;
  const region = config?.s3?.REGION || "ap-southeast-2";
  const listUrl = `https://s3.${region}.amazonaws.com/${bucket}?prefix=${encodeURIComponent(path)}`;

  try {
    const response = await fetch(listUrl, {
      method: "GET",
    });

    if (!response.ok) {
      throw new Error(`S3 list request failed with status ${response.status}`);
    }

    const xmlText = await response.text();
    const parser = new DOMParser();
    const xml = parser.parseFromString(xmlText, "application/xml");
    const keyNodes = Array.from(xml.getElementsByTagName("Contents"));

    const items = keyNodes
      .map((node) => {
        const key = node.getElementsByTagName("Key")[0]?.textContent || "";
        const lastModified = node.getElementsByTagName("LastModified")[0]?.textContent || "";
        const eTag = node.getElementsByTagName("ETag")[0]?.textContent || "";
        const sizeText = node.getElementsByTagName("Size")[0]?.textContent || "0";

        return {
          key,
          lastModified,
          eTag,
          size: Number(sizeText || 0),
        };
      })
      .filter((item) => item.key.startsWith(path));

    return {
      items,
    };
  } catch (error) {
    console.warn("Direct prefix-only S3 list failed; falling back to Amplify list:", error);

    const fallbackResult = await list({
      path,
      options: {
        listAll: true,
      },
    });

    const items = (fallbackResult?.items || [])
      .map((item) => {
        const key = item?.key || item?.path || "";
        return {
          ...item,
          key,
        };
      })
      .filter((item) => item.key.startsWith(path));

    return {
      ...fallbackResult,
      items,
    };
  }
}
